<template>
  <div
    v-if="!uiStore.hidePrices && !globalContent.hidePricesForSamplesOnly && !globalContent.getIsGlobalMarket && !showDisplayOnlyPrice"
    class="ProductPrice relative type-sm "
    :class="{
      'mb-10': design === 'plpGrid',
      'mb-24 gap-0 desk:gap-2 ': design !== 'plpGrid' && design !== 'list' && design !== 'plpCompact'
    }"
  >
    <div v-if="userPrice.status === 'ok' && design === 'standard'">
      <p
        v-for="(flag, index) in displayFlags"
        :key="'flag-' + flag.text"
        class="inline-block type-headline-sm text-text-brandStrong uppercase mb-6"
      >
        {{ flag.text }}
        <span v-if="index + 1 !== displayFlags.length">
          -
        </span>
      </p>
    </div>
    <div
      v-if="userPrice.status === 'logginIn' || userPrice.status === 'pending'"
      class="priceLoadBox"
    />
    <div v-else-if="shouldUseArea && userPrice.status === 'ok'" class="mb-4">
      <div v-if="design === 'list'" class="type-headline-sm">{{ productPrice(userPrice.price, 'price', true) }}</div>
      <p
        v-if="uiStore.overrideDisplayPrice > -1 && design === 'standard'"
        class="whitespace-nowrap type-headline-lg inline-block mr-12 text-text-errorStrong"
      >
        {{ useLocalizedCurrency(overrideAreaPrice) }}<span v-if="taxLabel"> {{ taxLabel }}</span>/{{ unitDisplay }}
      </p>
      <p
        v-if="convertPackageToAreaprice.status === 'ok' && areaPrice != null"
        class="whitespace-nowrap text-darkest inline-block"
        :class="{
          '!text-text-errorStrong': userPrice.price?.isCampaignPrice,
          'type-headline-lg': design === 'standard',
          'type-text-xs': design === 'list' || design === 'plpCompact',
          'type-base mb-2': design === 'plpGrid',
          '!text-text-subtle line-through': uiStore.overrideDisplayPrice > -1 && design === 'standard'
        }"
      >
        {{ useLocalizedCurrency(areaPrice) }}<span v-if="taxLabel" class="pl-4"> {{ taxLabel }}</span>/{{ unitDisplay }}
      </p>
      <!-- if user has discount -->
      <div
        v-if="userPrice.price?.isCampaignPrice && convertPackageToAreaprice.status === 'ok' && areaPriceBeforeDiscount && areaPrice !== areaPriceBeforeDiscount && !globalContent.hideSRP"
        class="whitespace-nowrap text-text-subtle inline-block type-text-sm  line-through"
        :class="{
          'ml-6': design !== 'plpCompact',
          '!block': design === 'plpCompact',
        }"
      >
        {{ useLocalizedCurrency(areaPriceBeforeDiscount) }}<span v-if="taxLabel"> {{ taxLabel }}</span>/{{ unitDisplay }}
      </div>
      <!-- check if we override price, the reason we override price is that quantity breaks is reached -->
      <p v-if="uiStore.overrideDisplayPrice > -1 && design === 'standard'" class="pt-4">
        <span>{{
          $t('areaConvert.pricePerPack', { price: useLocalizedCurrency(uiStore.overrideDisplayPrice) })
        }}</span>

        <span
          v-if="((userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted) && !globalContent.hideSRP"
          class="text-dark line-through inline-block ml-8"
          :class="{'leading-single': design === 'list' || design === 'plpGrid'}"
        >
          {{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}
        </span>
      </p>
      <p v-else-if="design === 'standard'" class="pt-4">
        <span>{{ $t('areaConvert.pricePerPack', { price: productPrice(userPrice.price, 'price', true) }) }}</span>
        <span
          v-if="((userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted) && !globalContent.hideSRP"
          class="text-dark line-through inline-block ml-8"
        >
          &nbsp;{{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}
        </span>
      </p>
    </div>
    <p
      v-else-if="userPrice.status === 'ok'"
      class="whitespace-nowrap text-darkest type-headline-lg"
      :class="{
        'text-criticalDark': isUserDiscounted,
        'type-headline-xl': design !== 'standard',
        'type-sm-medium': design === 'plpGrid' ,
        'type-headline-sm': design === 'list' || design !== 'plpCompact',
        '!type-sm': design === 'list' || design === 'plpCompact',
      }"
    >
      {{ productPrice(userPrice.price, 'price', true) }}<span v-if="taxLabel"> {{ taxLabel }}</span>
    </p>
    <!-- Price for non-logged-in B2B users (DE) - area price -->
    <div
      v-else-if="userPrice.status === 'notLoggedIn' && globalContent.getShowPriceNonLoggedInB2B && shouldUseArea"
      class="mb-4"
    >
      <p
        class="whitespace-nowrap text-darkest inline-block"
        :class="{
          'type-headline-lg': design === 'standard',
          'type-text-xs': design === 'list' || design === 'plpCompact',
          'type-base': design === 'plpGrid',
        }"
      >
        {{ useLocalizedCurrency(convertPackagePriceToAreaPrice(props.activeVariant.priceInfo?.price)) }}/{{ unitDisplay }}
      </p>
      <p v-if="design === 'standard'" class="mt-8 text-text-subtle">
        {{ $t('price.incVat.shown') }}
      </p>
    </div>
    <!-- Price for non-logged-in B2B users (DE) - package price -->
    <div
      v-else-if="userPrice.status === 'notLoggedIn' && globalContent.getShowPriceNonLoggedInB2B"
    >
      <p
        class="whitespace-nowrap text-darkest"
        :class="{
          'type-headline-lg': design === 'standard',
          'type-base': design === 'plpGrid',
          '!type-sm': design === 'list' || design === 'plpCompact',
        }"
      >
        {{ props.activeVariant.priceInfo?.priceDisplay }}
      </p>
      <p v-if="design === 'standard'" class="mt-8 text-text-subtle">
        {{ $t('price.incVat.shown') }}
      </p>
    </div>
    <!-- DONT SHOW FOR NOW -->
    <!--    <p-->
    <!--      v-if="!shouldUseArea && ((userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted)"-->
    <!--      class="text-dark"-->
    <!--      :class="{'leading-single': design === 'list' || design === 'plpGrid'}"-->
    <!--    >-->
    <!--      {{ $t('productPage.price.original') }} {{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}-->
    <!--      <span v-if="userPrice.price?.isCustomerPrice" :class="{'hidden': design === 'list' || design === 'plpGrid'}">-->
    <!--        ({{ $t('productPage.price.yourDiscount') }} <span class="text-criticalDark">{{ userPrice.price?.discountPercentage }}%</span>)-->
    <!--      </span>-->
    <!--    </p>-->

    <!-- "Your discount: X%" -->
    <!--    <p
      v-if="recommendedPrice && design !== 'list' && userPrice.price?.isCampaignPrice && userPrice.price?.discountPercentage && userPrice.price.discountPercentage > 0"
      class="type-sm text-text-inactive desk:type-sm text-dark mb-8 mt-4"
      :class="{
        'leading-single': design === 'plpGrid',
      }"
    >
      {{ $t('priceInfo.yourDiscount.percent' ) }}<span class="type-headline-sm text-text-errorStrong"> {{ userPrice.price.discountPercentage }}%</span>
    </p>-->

    <!-- recommended price -->
    <p
      v-if="recommendedPrice && design !== 'list' && design !== 'plpCompact' && !globalContent.hideSRP && !globalContent.getIsB2c"
      class="type-xs desk:type-sm text-dark"
      :class="{
        'leading-single': design === 'plpGrid',
      }"
    >
      <span>{{ $t('product.recommendedPrice.short') }} {{ recommendedPrice }}</span>
    </p>
    <p
      v-if="design === 'standard' && userPrice.status === 'ok' && !globalContent.hideSRP"
      class="mt-8 text-text-subtle"
    >
      {{ globalContent.getDisplayIncVat ? $t('price.incVat.short'):$t('price.exVat.short') }}
    </p>

    <p
      v-if="design === 'plpGrid' && globalContent.getIsB2c"
      class="mt-4 text-text-subtle"
    >
      {{ globalContent.getDisplayIncVat ? $t('price.incVat.rec'):$t('price.exVat.rec') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { ProductModel } from '#models/product';
import type { ProductVariantModel } from '#models/productVariant';
import { useUserStore } from '~/store/user';
import usePrices from '~/composables/usePrices';
import usePackageAreaConverter from '~/composables/usePackageAreaConverter';
import { useLocalizedCurrency } from '~/composables/useLocalizedCurrency';
import { useGlobalContentStore } from '~/store/globalContent';
import { useUiStore } from '~/store/ui';
import useWarehouse from '~/composables/useWarehouse';
import useProductPurchase from '~/composables/useProductPurchase';

const globalContent = useGlobalContentStore();
const uiStore = useUiStore();
const { getVariantStockValue } = useWarehouse();
const { shouldShowDisplayOnlyPrice } = useProductPurchase();

/**
 * plpCompact is almost the same as list, except it doesn't show package price
 */
const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
  crossell?: boolean,
  design: 'standard' | 'list' | 'plpGrid' | 'plpCompact',
  pricePartNoOverride?: string,
}>();

const userStore = useUserStore();

const { productPrice } = usePrices();

const { convertPackageToAreaprice, unitDisplay, shouldUseArea ,convertPackagePriceToAreaPrice } = usePackageAreaConverter(toRef(()=>props.activeVariant));

const userPrice = computed(()=> {
  if (props.pricePartNoOverride) {
    return userStore.getPriceWithFallback(props.pricePartNoOverride, props.activeVariant.partNo, props.crossell ?? false);
  }
  return userStore.getPrice(props.activeVariant.partNo, props.crossell ?? false);
});

/**
 * Check if this is a displayOnly product that user doesn't have on their pricelist
 * Used to hide price entirely for these products
 */
const showDisplayOnlyPrice = computed(() => {
  return shouldShowDisplayOnlyPrice(props.productItem);
});

const isUserDiscounted = computed(()=> {
  return userStore.isSalePrice(props.activeVariant.partNo);
});

const displayFlags = computed(()=> {
  const stockValue = getVariantStockValue(props.activeVariant);
  const isInStock = stockValue > 0;
  if (isInStock) {
    return props.productItem.displayFlags.filter((f)=> f.code !== 'onDemand');
  }
  return props.productItem.displayFlags;
});

const areaPrice = computed(()=> {
  if (shouldUseArea.value && userPrice.value.status === 'ok') {
    return globalContent.getDisplayIncVat ? convertPackageToAreaprice.value.price?.price : convertPackageToAreaprice.value.price?.priceBeforeVat;
  }
  return null;
});

const areaPriceBeforeDiscount = computed(()=> {
  if (shouldUseArea.value && userPrice.value.status === 'ok') {
    return globalContent.getDisplayIncVat ? convertPackageToAreaprice.value.price?.priceBeforeDiscount : convertPackageToAreaprice.value.price?.priceBeforeDiscountBeforeVat;
  }
  return null;
});

const overrideAreaPrice = computed(()=> {
  if (shouldUseArea.value && uiStore.overrideDisplayPrice > -1 && props.design === 'standard') {
    return convertPackagePriceToAreaPrice(uiStore.overrideDisplayPrice);
  }
  return null;
});

/**
 * @todo - this doesn't work since recommendedPrice is wrong and recommendedPriceBeforeVat is missing
 */
const taxLabel = computed(() => {
  if (globalContent.getCountryCode !== 'fr') { return ''; }
  return globalContent.getIsB2b ? 'HT' : 'TTC';
});

const recommendedPrice = computed(()=> {
  if (!userPrice.value.price?.recommendedPrice) {
    return null;
  }

  /*  if (userPrice.value.price?.priceBeforeDiscountBeforeVat === userPrice.value.price?.recommendedPrice && !userPrice.value.price?.isCampaignPrice) {
    return null;
  }*/

  const convertPrice = parseFloat(userPrice.value?.price?.recommendedPrice) || -1;

  if (shouldUseArea.value) {

    /*if (globalContent.getDisplayIncVat) {
      convertPrice = parseFloat(userPrice.value?.price?.recommendedPrice) || -1;
    } else {
      convertPrice = parseFloat(userPrice.value?.price?.recommendedPriceBeforeVat) || -1;
    }*/
    if (convertPrice === -1) {
      return null;
    }

    return useLocalizedCurrency(convertPackagePriceToAreaPrice(convertPrice)) + '/' + unitDisplay;
  }
  //return globalContent.getDisplayIncVat ? userPrice.value?.price?.recommendedPriceDisplay : userPrice.value?.price?.recommendedPriceBeforeVatDisplay;
  return useLocalizedCurrency(convertPrice);
});

</script>

<style scoped lang="postcss">

.priceLoadBox {
  @apply block mt-4 w-64 min-h-24;
  color: rgba(0,0,0,0);
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
}

@keyframes spin {
  from {
    background-color: #DEDDD9;
  }
  to {
    background-color: #F5F4F0;
  }
}

</style>
